import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getAverageSalariesByYear = actionFactory(
  types.GET_AVERAGE_SALARY_BY_YEAR,
);
export const addAverageSalary = actionFactory(types.ADD_AVERAGE_SALARY);
export const updateAverageSalary = actionFactory(types.UPDATE_AVERAGE_SALARY);
